import React from "react";

export const CountryFlag = (props:{name:string})=>{
    return <span className={'everyones-smile__country-flag-wrapper'}><img className={'everyones-smile__country-flag'}
                                                                          src={`./img/png100px/${props.name.toLowerCase()}.png`}
                                                                          alt=""/></span>
};